import { apiService } from "./apiService";
import { IHelpCategory, IHelpContent } from "src/modules/UserSettings/Help/types/help";

export const HelpService = {
  getCategories: (): Promise<IHelpCategory[]> => {
    return apiService.get('/api/help').then(res => {
      const { data } = res
      return res.status === 200 && data.content ? data.content as IHelpCategory[] : [];
    });
  },
  saveContent: (content: IHelpContent, type: string) => {
    return apiService.post('/api/help', { content, type });
  },
  getArticleById: (articleId: string): Promise<IHelpContent | undefined> => {
    return apiService.get(`/api/help/article/${articleId}`).then(res => {
      const { data } = res
      return res.status === 200 && data.article ? data.article as IHelpContent : undefined;
    });
  },
  deleteArticleById: (articleId: string) => {
    return apiService.delete(`/api/help/article/${articleId}`);
  },
  getCategoryById: (categoryId: string): Promise<IHelpContent | undefined> => {
    return apiService.get(`/api/help/category/${categoryId}`).then(res => {
      const { data } = res
      return res.status === 200 && data.category ? data.category as IHelpContent : undefined;
    });
  },
  deleteCategoryById: (categoryId: string) => {
    return apiService.delete(`/api/help/category/${categoryId}`);
  }
}


// WEBPACK FOOTER //
// ./src/share/services/help.ts